<div class="list-detail">
    <div class="list-detail_col-primary">
        <div class=" heade-idea d-flex mt-4">
            <svg-icon class="is-cursor" [routerLink]="'/my-list-kaizen'" src="assets/svg/arrow.svg"></svg-icon>
            <h1 class="list-detail_title"><span>{{ideaKaizen?.code}} |</span> {{ideaKaizen?.title}}</h1>
            <div class="register-date">
                <dl>
                    <dt class="list-detail_lbl">{{translate.instant('registration_date')}}</dt>
                    <dd class="list-detail_value">{{ ideaKaizen?.initialDate | date:'dd/MM/yyyy'}}</dd>
                </dl>
            </div>
        </div>
        <div class="infor-committee">
            <p><span>Autor:</span> {{ideaKaizen?.re}} - {{ideaKaizen?.authorName}}</p>
            <p *ngIf="isIdeaClic"><span>Ideia Clic convertida em ideia kaizen</span> <img id="verify-clic" src="../../../assets/svg/verify-clic.svg" alt=""></p>
        </div>
        <div class="status">
                <div>
                    <label for="status">{{translate.instant('unity')}}</label>
                    <select 
                        [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' "
                        [(ngModel)]="ideaUnity" 
                        name="ideaUnity" 
                        id="unity"
                        (change)="updateUnity()"
                    >
                        <option *ngFor="let item of listUnity" [value]="item.id">
                            {{item.name}}
                        </option>
                    </select>
                </div>
                <div>
                    <label for="frame">{{translate.instant('frame')}}</label>
                    <select [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " (change)="updateFrame()" [(ngModel)]="ideaFrame" name="ideaFrame" id="frame">
                        <option *ngFor="let frame of frames" [value]="frame.id">{{frame.name}}</option>
                    </select>
                </div>
                <div class="container-input line">
                    <label for="line">{{translate.instant('line')}}</label>
                    <select 
                        [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " 
                        [(ngModel)]="ideaLine" 
                        (change)="updateLine()" 
                        id="line"
                    >
                        <option *ngFor="let line of lines" [value]="line.id">{{line.name}}</option>
                    </select>
                </div>
                <div>
                    <label for="status">{{translate.instant('status')}}</label>
                    <select 
                        [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' "
                        [(ngModel)]="ideaStatus" 
                        name="ideaStatus" 
                        id="status"
                        (change)="updateStatus()"
                    >
                        <option 
                            [disabled]="item.value === 'awarded' || 
                            item.value === 'approved'" 
                            *ngFor="let item of status" [value]="item.value"
                        >
                            {{item.name}}
                        </option>
                    </select>
                </div>
        </div>

        <div class="infor-idea">
            <div class="photo">
                <h3>{{translate.instant('kaizen_card')}}</h3>
                <button (click)="openModalImage()">{{translate.instant('to_view')}}</button>
                <img [src]="bucketUrl" alt="">
            </div>
            <div class="content">
                <div class="problem">
                    <h4>{{translate.instant('problem')}}</h4>
                    <div>
                        <textarea type="text" [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " [value]="ideaKaizen?.problem" [(ngModel)]="problem" (change)="updateProblem()" maxlength="255" cols="30" rows="5" placeholder="Essa ideia ainda não possui problema"></textarea>
                    </div>
                </div>
                <div class="solution">
                    <h4>{{translate.instant('possible_solutions')}}</h4>
                    <div>
                        <textarea type="text" [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " [value]="ideaKaizen?.solution" [(ngModel)]="solution" (change)="updateSolution()" maxlength="255" cols="1" rows="5" placeholder="Essa ideia ainda não possui solução"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="image-overlay" *ngIf="imageVisible" (click)="closeModalImage()">
            <img [src]="bucketUrl" alt="Imagem em tela cheia">
        </div>

        <div class="other-authors-container">
            <div class="other-authors-btn-container">
                <h4>Outros autores</h4>
                <button *ngIf="isPossibleViewOtherAuthors" (click)="toggleVisibilityOfAuthors()">
                    <img [src]="'../../../assets/svg/pull-' + (tableOfAuthorsIsVisible ? 'up' : 'down') + '.svg'">
                </button>
            </div>
            <div class="other-authors" [ngClass]="{
                    'table-Authors-visible': tableOfAuthorsIsVisible,
                    'other-author-hidden': !isPossibleViewOtherAuthors
                }">
                <p *ngIf="!isPossibleViewOtherAuthors">Esta ideia não possui outros autores</p>
                <table [ngClass]="tableOfAuthorsIsVisible ? 'table-Authors-visible' : ''" *ngIf="isPossibleViewOtherAuthors" class="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Re</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of ideaAuthors; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td>{{ item?.name }}</td>
                        <td>{{ item?.re }}</td>
                      </tr>
                    </tbody>
                  </table>            
            </div>
        </div>

        <div class="todo-list">
            <div class="todo-progress">
                <p>{{translate.instant('verification_list')}} {{todoCount}} / {{todoTotal}}</p>
                <div class="progress" [style.width.%]="progress"></div>
                <div class="container-btns">
                    <button [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " class="add-item" (click)="showModalAddItem()">+</button>
                    <button class="close-all" (click)="closeAllItems()">&#9662;</button>
                </div>
            </div>
            <div class="content">
                <div class="list">
                    <div class="item" *ngFor="let item of tasks">
                        <div class="item-description" [ngClass]="{'completed': item.completed}">
                            <img [src]="item.detailsVisible ? '../../../assets/images/eye-open.svg' : '../../../assets/images/eye-close.svg' "
                                alt="" (click)="toggleEye(item)">
                            <span [ngClass]="{'completed': item?.completed}"></span>
                            <p>{{ item.task }}</p>
                        </div>
                        <div *ngIf="item.detailsVisible" class="container-input">
                            <div class="content-input">
                                <label for="resp">Resp.:</label>
                                <input [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " class="resp" type="text" [value]="item.responsible" [(ngModel)]="item.responsible" name="resp"
                                    id="resp">
                            </div>
                            <div class="content-input">
                                <label for="deadline">{{translate.instant('deadline')}}:</label>
                                <input [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " class="date" type="date" [value]="item.deadline" [(ngModel)]="item.deadline" name="deadline"
                                    id="deadline">
                            </div>
                            <div class="content-input">
                                <label for="finishedIn" class="conclusion">{{translate.instant('finished_in')}}:</label>
                                <input [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " class="date" type="date" [max]="datePicker" [value]="item.finishedIn" [(ngModel)]="item.finishedIn"
                                    name="finishedIn" id="finishedIn">
                            </div>
                            <div class="content-btn">
                                <button [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " (click)="saveItemList(item)">
                                    {{translate.instant('save')}}
                                </button>
                                <button [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " class="btn-delete" (click)="deleteItemList(item)">
                                    <img src="../../../assets/images/delete.svg" alt="">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-conclude">
                <button [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " (click)="conclude()">{{translate.instant('conclude')}}</button>
            </div>
        </div>

        <div class="modal-custom modal fade" id="modalAddItemInTodo" data-keyboard="false" data-backdrop="static"
            role="dialog" aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content p-0">
                    <div class="modal-header align-items-center bg-gray" style="min-height: 107px;">
                        <h2 class="modal-title">{{translate.instant('newItem')}}</h2>
                        <a data-dismiss="modal" class="modal_close" aria-label="Close">
                            <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                        </a>
                    </div>
                    <div class="modal-body p-3 p-md-4">
                        <div class="d-flex flex-wrap" style="column-gap: 30px">
                            <div class="flex-grow-1">
                                <div class="input-material">
                                    <input id="description" [(ngModel)]="modelItem.text" class="form-control"
                                        type="text" required />
                                    <label style="top: 0; left: 11px;" for="description">
                                        {{translate.instant('descriptionItem')}}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-wrap" style="column-gap: 30px">
                            <div class="flex-grow-1">
                                <div class="input-material">
                                    <input id="resp" [(ngModel)]="modelItem.resp" class="form-control" type="text"
                                        required />
                                    <label style="top: 0; left: 11px;" for="resp">
                                        {{translate.instant('respItem')}}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-wrap" style="column-gap: 30px">
                            <div class="flex-grow-1">
                                <div class="input-material">
                                    <input id="term" [(ngModel)]="modelItem.term"
                                        class="form-control ng-pristine ng-valid ng-touched" type="date" required />
                                    <label style="top: 0; left: 11px;" for="term">
                                        {{translate.instant('term')}}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-wrap" style="column-gap: 30px">
                            <div class="flex-grow-1">
                                <div class="input-material">
                                    <input id="finishedIn" [(ngModel)]="modelItem.finishedIn"
                                        class="form-control ng-pristine ng-valid ng-touched" type="date" [max]="datePicker" required />
                                    <label style="top: 0; left: 11px;" for="finishedIn">
                                        {{translate.instant('finishedIn')}}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-grow-1" style="gap: 30px;max-width: 394px;margin: 0 auto">
                            <a class="btn flex-grow-1 btn-outline-primary" data-dismiss="modal"
                                aria-label="Close">Cancelar</a>
                            <a class="btn flex-grow-1 btn-primary" (click)="addItem(modelItem);">Criar</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="comment-container">
            <div class="input-container">
                <label for="comment">{{translate.instant('comments')}}</label>
                <input [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " id="comment" type="text" maxlength="255" [value]="comment" [(ngModel)]="comment" placeholder="Digite aqui sua mensagem">
            </div>
            <div class="btn-container">
                <button class="view-comment" (click)="toggleComment()">
                    <span></span>
                    {{translate.instant('see_comments')}}
                    <span>&#9660;</span>
                </button>
                <button [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " class="send" (click)="createComment()">{{translate.instant('send')}}</button>
            </div>

            <div *ngIf="commentsIsVisible">
                <div *ngFor="let item of comments" class="comment">
                    <img width="30" height="30" src="../../../assets/images/user.png" alt="foto do usuário">
                    <div class="text">
                        <div class="name-and-date">
                            <p>{{item?.user?.name}}</p>
                            <p>{{item?.createdAt}}</p>
                        </div>
                        <p class="message">{{item?.comment}}</p>
                    </div>
                    <button [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " *ngIf="item?.user.id === this.user.id" (click)="deleteComment(item?.commentId)">
                        <img src="../../../assets/images/delete.svg" alt="">
                    </button>
                </div>
            </div>
        </div>

        <!-- Anexos (sem a imagem do cartão); adicionar/remover quando canManageFiles -->
        <div class="kaizen-files">
            <p class="kaizen-files__title">{{ 'attachments.label' | translate }}</p>
            <app-idea-files flow="kaizen" [ideaId]="ideaKaizen?.id" [files]="kaizenFiles"
                [canManage]="canManageFiles" (changed)="getAllFiles(ideaKaizen?.id)"></app-idea-files>
        </div>

        <div class="result">
            <button class="view-result" (click)="toggleWinnings()">
                <span></span>
                {{translate.instant('results')}}
                <span>&#9660;</span>
            </button>

            <div *ngIf="winnings" class="infor-result">
                <div class="results">
                    <div>
                        <label for="financial"> {{translate.instant('financial_gain')}}</label>
                        <input [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " (blur)="buttonAproveIsDisabled()" type="number" [value]="financial" [(ngModel)]="financial" id="financial">
                    </div>
                    <div>
                        <label for="productivity"> {{translate.instant('gain_productivity')}}</label>
                        <input [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " (blur)="buttonAproveIsDisabled()" type="number" [value]="productivity" [(ngModel)]="productivity" id="productivity">
                    </div>
                    <div>
                        <label for="sustainability"> {{translate.instant('gain_sustainability')}}</label>
                        <input [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " (blur)="buttonAproveIsDisabled()" type="number" [value]="sustainability" [(ngModel)]="sustainability" id="sustainability">
                    </div>
                </div>

                <button [disabled]="ideaStatus === 'awarded' || ideaStatus === 'approved' " (click)="saveResultsIdea()" class="btn-save">
                    {{translate.instant('save_results')}}
                </button>
            </div>

            <div class="btns">
                <div class="container-btn">
                    <button [disabled]="buttonAproveDisabled || ideaStatus === 'awarded' || ideaStatus === 'approved' " (click)="aproveIdea()" [disabled]="" class="btn-approve">
                        {{translate.instant('go_to_idea_click')}}
                    </button>
                </div>
                <button class="btn-clic">
                </button>
            </div>
        </div>
    </div>
</div>